import styled from 'styled-components';

import { Text } from '../../../../components';
import { ANIM, COLORS, MOBILE, SPACE } from '../../../../theme/tokens';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[12]};
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: ${SPACE[12]} ${SPACE[16]};

  ${MOBILE} {
    justify-content: flex-start;
  }
`;

export const LanguageSlot = styled.div`
  min-width: 160px;
`;

/* The quiet "unsaved" cue, the same look as Game Lists' (a soft publish-blue dot and a muted label). */
export const DirtyNote = styled(Text)`
  display: inline-flex;
  align-items: center;
  gap: ${SPACE[8]};
  font-size: 12px;
  color: ${COLORS.textMuted};

  &::before {
    content: '';
    width: 7px;
    height: 7px;
    border-radius: 999px;
    background: ${COLORS.publishBlue};
  }
`;

export const JobNote = styled(Text)`
  font-size: 12px;
  color: ${COLORS.textMuted};
`;

/* Publish: the primary publish-blue pill, the same look as Game Lists' Publish to site. `aria-disabled` rather than
   `disabled`, so its title (why it is blocked) still shows on hover. */
export const PublishBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: ${SPACE[8]};
  /* 9px: the pill's optical height against its 1px border, as Game Lists' Publish to site. */
  padding: 9px 18px;
  border-radius: 999px;
  border: 1px solid ${COLORS.publishBlue};
  background: ${COLORS.publishBlue};
  color: ${COLORS.ctaSolidText};
  font-family: inherit;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: filter ${ANIM.CREATIVE_HOVER_MS}ms ${ANIM.EASE};

  &:hover:not([aria-disabled='true']) {
    filter: brightness(1.06);
  }
  &[aria-disabled='true'] {
    opacity: 0.45;
    cursor: default;
  }
`;
